export const isUserFillProfile = (user) => {
  return user?.gender !== "" && user?.occupationSector !== "" && user?.shortBio !== "" && user?.birthDate !== "" &&
    user?.instagram !== "" && user?.interests?.length > 0 && user?.imgUrl?.length > 0;
};
